import { render } from "./PendingPrs.vue?vue&type=template&id=7f16afcd"
import script from "./PendingPrs.vue?vue&type=script&lang=js"
export * from "./PendingPrs.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__